// extracted by mini-css-extract-plugin
export var dividerLine = "_3r-0";
export var errorBackground = "_3r-1";